module.exports = __webpack_public_path__ + "static/media/todo.9ee918fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/todo.png
// module id = 55
// module chunks = 0